import * as types from "../ActionType";

const initState = {
    statistics: {},
    loadingStatistics: true,
    generalStatic: {},
    loadingGeneralStatic: true,
    statisticsWorkPlan: {},
    loadingStatisticsWorkPlan: true,
    statisticsExternal: [],
    loadingStatisticsExternal: true,
    statisticsTarget: {},
    loadingStatisticsTarget: true,
    statisticsTargetWithSearch: {},
    loadingStatisticsTargetWithSearch: true,
    // Phase 2 — drill-down, time-series, targets
    repPerformanceDetails: null,
    monthlyTimeSeries: [],
    repTargets: {},
    // Phase 3 — templates, smart cards
    reportTemplates: [],
    smartCards: { recent: [], favorites: [] },
    // Phase 4 — scheduled reports, dashboard layout
    scheduledReports: [],
    dashboardLayout: null,
}

const StatisticsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_ALL_STATISTICS:
            return { ...state, statistics: action.payload, loadingStatistics: false }
        case types.EMPTY_ALL_STATISTICS:
            return { ...state, statistics: action.payload, loadingStatistics: false }

        case types.GET_STATISTICS_TARGET_GROUP_WITH_MEDICAL_REP:
            return { ...state, statisticsTargetWithSearch: action.payload, loadingStatisticsTargetWithSearch: false }
        case types.EMPTY_ALL_STATISTICS_TARGET_GROUP_WITH_MEDICAL_REP:
            return { ...state, statisticsTargetWithSearch: action.payload, loadingStatisticsTargetWithSearch: false }
       
            case types.GET_GENERAL_STATIC:
            return { ...state, generalStatic: action.payload, loadingGeneralStatic: false }
        case types.GET_STATISTICS_WORK_PLANS:
            return { ...state, statisticsWorkPlan: action.payload, loadingStatisticsWorkPlan: false }
        case types.GET_STATISTICS_EXTERNAL_VISITE:
            return { ...state, statisticsExternal: action.payload, loadingStatisticsExternal: false }
        case types.GET_STATISTICS_TARGET_GROUP:
            return { ...state, statisticsTarget: action.payload, loadingStatisticsTarget: false }

        // Phase 2
        case types.GET_REP_PERFORMANCE_DETAILS:
            return { ...state, repPerformanceDetails: action.payload }
        case types.GET_MONTHLY_TIME_SERIES:
            return { ...state, monthlyTimeSeries: action.payload }
        case types.GET_REP_TARGETS:
            return { ...state, repTargets: action.payload }

        // Phase 3
        case types.GET_REPORT_TEMPLATES:
            return { ...state, reportTemplates: action.payload }
        case types.GET_SMART_CARDS:
            return { ...state, smartCards: action.payload }

        // Phase 4
        case types.GET_SCHEDULED_REPORTS:
            return { ...state, scheduledReports: action.payload }
        case types.GET_DASHBOARD_LAYOUT:
            return { ...state, dashboardLayout: action.payload }

        default:
            return state;
    }
};

export default StatisticsReducer;
